import React from "react";
import "../../page_content.css";

const ScheduleGuid = () => {
  // First Table: Admission Schedule
  const admissionSchedule = [
    {
      description: "Availability of MANET Application Form",
      tentativeDate: "1st Jan 2026",
    },
    {
      description: "Last date for filling MANET Application Form",
      tentativeDate: "30th May 2026",
    },
    {
      description: "Last date for filling IMU CET Application Form",
      tentativeDate: "24th April 2026",
    },
    {
      description: "IMU CET Entrance Exam",
      tentativeDate: "24th May 2026",
    },
    {
      description: "MANET Admission Rounds",
      tentativeDate: "June/July 2025",
    },
    {
      description: "Date of Commencement of Classes",
      tentativeDate: "1stAugust 2025",
    },
  ];

  // Second Table: Admission Team Members
  const admissionTeam = [
    {
      name: "Prof. Sunil Chawale",
      desg: "HOD Admissions",
      mobile: "7774062352",
    },
    {
      name: "Mr. Nilesh Jagtap",
      desg: "Admission Coordinator",
      mobile: "8308010405",
    },
    {
      name: "Ms. Priti Deshmukh",
      desg: "Admission Counsellor",
      mobile: "7774062351",
    },
    {
      name: "Ms. Avantika Dharangaonkar",
      desg: "Admission Counsellor",
      mobile: "7774062353",
    },
    {
      name: "Ms. Swapna Navale",
      desg: "Admission Counsellor",
      mobile: "7774062354",
    },
    {
      name: "Ms. Arti Bhosale",
      desg: "Admission Counsellor",
      mobile: "8983185778",
    },
    {
      name: "Mr. Baliram Maske",
      desg: "Admission Counsellor",
      mobile: "7391095155",
    },
  ];

  return (
    <div>
      <h1 className="title">Schedule Guideline </h1>
      <hr />
      <div>
        <table className="page-content-table" >
          <thead>
            <tr>
              <th>Description</th>
              <th>Tentative Date</th>
            </tr>
          </thead>
          <tbody>
            {admissionSchedule.map((item, index) => (
              <tr key={index}>
                <td>{item.description}</td>
                <td>{item.tentativeDate}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Add some space between tables */}
        <div style={{ height: "20px" }}></div>
        <table className="page-content-table">
          <thead>
            <tr>
              <th>Admission Team Member</th>
              <th>Designation</th>
              <th>Mobile No.</th>
            </tr>
          </thead>
          <tbody>
            {admissionTeam.map((member, index) => (
              <tr key={index}>
                <td>{member.name}</td>
                <td>{member.desg}</td>
                <td>
                  <a href={`tel:${member.mobile}`}>{member.mobile}</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <h4 className="innerpage-subheading">Guideline</h4>
        <hr />
        <ul className="page-content-lists">
          <li>
            The admission procedure includes all the details related to the
            eligibility and medical requirements of prospective cadets.
          </li>
          <li>
            All the admissions to MANET are done based on UGC guidelines, D.G.
            Shipping, AICTE norms, and based on merit.
          </li>
          <li>
            Candidates can submit the "Online Application" through the link
            provided over the website.
          </li>
          <li>
            The selection process tests candidates on parameters like
            Communication skills, Temperamental suitability for a sea career,
            Leadership qualities, Physical fitness, and Aptitude for scientific
            concepts by considering a candidate's 10+2 PCM marks, Performance in
            an interview, Satisfactory medical tests, and original document
            verification.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ScheduleGuid;
